import React from 'react';

export default function TermsAndCondsPage() {
  return <>TermsAndCondsPage placeholder</>;
}
